<template>
    <div class="terms">
        <!--Text for user terms of service-->
        <div class="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h4 class="modal-title ml-2">Terms of Service</h4>
                        <button class="close text-white" data-dismiss="modal" :style="close" aria-label="Close" @click="close">
                            <span aria-hidden="true"><h4><cancel-icon class="close-icon" style="height: 35px !important;width: 35px !important;color: #fff;"></cancel-icon></h4></span>
                        </button>
                    </div>
                    <div class="modal-body" style="overflow-y: scroll;">
                        <p class="terms-text"><strong>Effective Date:</strong> 01 June 2025</p>

                        <p class="terms-text">Welcome to <strong>Fusion</strong> ("Platform", "Service", "we", "us", or "our"). These Terms and Conditions ("Terms") govern your access to and use of our Digital Asset Management (DAM) web application.</p>

                        <p class="terms-text">By using the Service, you agree to be bound by these Terms. If you do not agree, you may not use our Service.</p>

                        <h4 class="terms-title">1. Eligibility</h4>
                        <p class="terms-text">You must be at least 18 years old and have the legal capacity to enter into a binding agreement. If you are using the Service on behalf of an organization, you represent and warrant that you have the authority to bind that organization.</p>

                        <h4 class="terms-title">2. Account Registration</h4>
                        <p class="terms-text">To use the Service, you must create an account and provide accurate and complete information. You are responsible for maintaining the confidentiality of your login credentials and are liable for all activities under your account.</p>

                        <h4 class="terms-title">3. User Content</h4>
                        <p class="terms-text">You retain ownership of any content (including images, videos, documents, and metadata) you upload to the Platform (“User Content”).</p>
                        <p class="terms-text">By uploading User Content, you grant us a non-exclusive, worldwide, royalty-free license to host, store, and display your content solely for the purpose of providing the Service.</p>
                        <p class="terms-text">You are responsible for ensuring that your content does not violate any laws or third-party rights (e.g., copyright, trademark, or privacy laws).</p>

                        <h4 class="terms-title">4. Prohibited Use</h4>
                        <p class="terms-text">You agree not to:</p>
                        <ul>
                            <li class="terms-list">Upload or share unlawful, harmful, or infringing content;</li>
                            <li class="terms-list">Interfere with the security or integrity of the Service;</li>
                            <li class="terms-list">Reverse engineer or attempt to gain unauthorized access;</li>
                            <li class="terms-list">Use automated means (e.g., bots or scrapers) without permission.</li>
                        </ul>

                        <h4 class="terms-title">5. Storage and Usage Limits</h4>
                        <p class="terms-text">Your use of storage and bandwidth is subject to the limits specified in your plan. We may suspend or restrict access if these limits are exceeded or abused.</p>

                        <h4 class="terms-title">6. Intellectual Property</h4>
                        <p class="terms-text">All software, trademarks, and content provided by us (excluding User Content) remain our intellectual property. You may not copy, distribute, or create derivative works from our platform without prior written consent.</p>

                        <h4 class="terms-title">7. Third-Party Services</h4>
                        <p class="terms-text">The Service may integrate with third-party services (e.g., cloud storage or analytics tools). We are not responsible for any third-party content or practices.</p>

                        <h4 class="terms-title">8. Privacy</h4>
                        <p class="terms-text">Our <a class="link" href="#" v-on:click="goToPrivacyPolicy()">Privacy Policy</a> explains how we collect, use, and protect your information. By using the Service, you consent to our data practices.</p>

                        <h4 class="terms-title">9. Termination</h4>
                        <p class="terms-text">We may suspend or terminate your account if you violate these Terms. You may terminate your account at any time. Upon termination, your access to the Service will cease, and we may delete your content after a grace period.</p>

                        <h4 class="terms-title">10. Disclaimer of Warranty</h4>
                        <p class="terms-text">The Service is provided “as is” and “as available.” We disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.</p>

                        <h4 class="terms-title">11. Limitation of Liability</h4>
                        <p class="terms-text">To the maximum extent permitted by law, we are not liable for any indirect, incidental, special, or consequential damages, or loss of data, revenue, or profits arising from your use of the Service.</p>

                        <h4 class="terms-title">12. Changes to Terms</h4>
                        <p class="terms-text">We may update these Terms from time to time. We will notify you by email or through the Service. Continued use of the Service after changes means you accept the updated Terms.</p>

                        <h4 class="terms-title">13. Governing Law</h4>
                        <p class="terms-text">These Terms shall be governed by the laws of India, without regard to its conflict of law provisions.</p>

                        <h4 class="terms-title">14. Contact Us</h4>
                        <p class="terms-text">If you have any questions about these Terms, contact us at:</p>
                        <ul>
                            <li class="terms-list"><strong>Email:</strong> <a class="link" href="mailto:support@workflowlabs.com">support@workflowlabs.com</a></li>
                            <li class="terms-list"><strong>Mailing Address:</strong> S. G. Towers, 2M-425, 2nd Main Rd, B Channasandra, East of NGEF Layout, Kasturi Nagar, Bengaluru, Karnataka 560043</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cancelIcon from "../core/InlineCancelField.vue"

export default {
    name: 'Terms',
    data() {
        return {
            parentRouteInfo:{},
            isClosed: false,
        };
    },
    components: {
        'cancel-icon':cancelIcon,
    },
    methods: {
        close() {
            this.isClosed = true
            if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
              console.log(this.$router.resolve({ name: this.parentRouteInfo.name }))
                this.$router.push({
                name: this.parentRouteInfo.name,
                params:this.parentRouteInfo.params,
                query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
              }).catch(err => {
                console.error("Navigation error:", err)
            })
            }else{
                if (this.$route.path.includes("explorer")) {
                    this.$router.push({
                        name: "explorer",
                    })
                }
                else {
                    this.$router.push({name:"login"})
                }
            }
        },
        goToPrivacyPolicy() {
            // If current page url has explorer in it, then go to privacy policy page
            if (this.$route.path.includes("explorer")) {
                this.$router.push({
                    name: "privacy_policy",
                    params: { parentinfo: this.parentRouteInfo }
                });
            } else {
                // If current page url does not have explorer in it, then go to privacy policy page
                this.$router.push({
                    name: "policy",
                    params: { parentinfo: this.parentRouteInfo }
                });
            }
        }
    },
    created() {
        console.log('Terms component created');
        Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})

    },
};
</script>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$active-green-color:#28a745;
$svg-color:#666;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$icon-hover:#2c3339;

.modal{
    display:block;        
}

.modal-title{
    margin-top:10px !important;
}

.modal-dialog {
    max-width:100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

.modal-content {
    height: 100%;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    pointer-events: all;
    background:$primary-background !important;
}

.modal-header,.modal-footer{
    border: $secondary-border-color !important;
    background: $secondary-background-color;
}
  
.modal-header{
    height:65px;
}
.modal-body {
    height:calc(100% - 65px);
    display:inline-block;
    width:100%;
  
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}
.terms-title {
    text-align: start;
}
.terms-text {
    text-align: start;
}
.terms-list{
    list-style: none;
    text-align: start;
    padding-inline-start: 1rem;
}
/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #141414;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #333;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.link,
.link:hover {
    color: #1d9bd1;
}
</style>